// extracted by mini-css-extract-plugin
export default {"page":"Z2sFmmIJ","wrapper":"Hdu30JJf","main":"G4IjcWLd","title":"VLnarS2i","cardsWrapper":"Ty4bKG9e","conditionsWrapper":"kUXF2JbZ","buttonsWrapper":"JK6MAyZX","accidentSection":"Y_Nr3_ec","accidentButton":"NoIb3mYY","backToGameButton":"mt4wYhxi"};
    if(module.hot) {
      // 1734636555866
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  